export default __webpack_public_path__ + "static/media/dsstest8.fb1d538e.jpg";